<template>
  <div class="lottery-wrapper" v-if="isshow">
    <div class="join_lottery" v-if="params">
      <div class="lottery_box">
        <p class="lottery_btn">编辑抽奖活动</p>
        <p class="information">基本信息</p>
        <div class="top_form">
          <assembly :level='level[0]' @delAwards="delAwards" :prizeData="winData"></assembly>
          <assembly :level='level[index+1]' v-for="(i, index) in arr" :key="index" :prizeMoreData="winMoreData" v-model="assemblyArr" @delAwards="delAwards"></assembly>
          <!-- <p class="add_prize" @click="add_prize" v-if='isadd'>添加{{level[isdefault]}}等奖</p> -->
        </div>
        <p class="information">其他设置</p>
        <el-form :rules="rules" ref="forms" :model="form" label-width="80px">
          <el-form-item label="开奖方式：" prop="resource">
            <el-radio-group v-model="form.resource">
              <el-radio label="1">手动开奖</el-radio>
              <el-radio label="2">发起抽奖</el-radio>
              <el-input-number class="number_text" v-model="form.minu" controls-position="right" :min="1"></el-input-number><span class="minu">分</span>
              <el-input-number class="number_text" v-model="form.secd" controls-position="right" :min="1" :max='59'></el-input-number><span class="minu">秒后自动开奖</span>
              <span>秒后自动开奖</span>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="参与方式：" prop="join">
            <el-radio-group v-model="form.join">
              <el-radio label="1">直播间全体学员自动参与</el-radio>
              <el-radio label="2">学员手动参与</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动规则：" prop="rule">
            <el-input placeholder='请输入，最多20字' maxlength=20 v-model="form.rule"></el-input>
          </el-form-item>
          <el-form-item label="指定中奖人：" prop="winner">
            <el-input placeholder='最多输入3个指定中奖人的手机号, 多个之间用&分隔开' maxlength=35 v-model="form.winner"></el-input>
            <div style="color:#999">指定中奖人需要进入直播间内参与抽奖</div>
          </el-form-item>
           <el-form-item class="create_btn">
            <el-button @click="onSubmit(0)">保存</el-button>
            <el-button @click="onCancel">取消</el-button>
            <!-- <el-button @click="onSubmit(1)">立即发起抽奖</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="join_lottery" v-else>
      <div class="lottery_box">
        <p class="lottery_btn"><span class="back_list" @click='back_list'><img src="./img/back.png"></span>创建抽奖活动</p>
        <p class="information">基本信息</p>
        <div class="top_form">
          <!-- <assembly :level='level[0]' @delAwards="delAwards" :prizeData="winData"></assembly>
          <assembly :level='level[index+1]' v-for="(i, index) in arr" :key="index" :prizeMoreData="winMoreData"  v-model="assemblyArr" @delAwards="delAwards"></assembly> -->
          <assembly @delAwards="delAwards" :prizeData="winData" @getSkuList="getSkuList"></assembly>
          <!-- <p class="add_prize" @click="add_prize" v-if='isadd'>添加{{level[isdefault]}}等奖</p> -->
        </div>
        <p class="information">其他设置</p>
        <el-form :rules="rules" ref="forms" :model="form" label-width="90px">
          <el-form-item label="开奖方式：" prop="resource">
            <el-radio-group v-model="form.resource">
              <el-radio :label="1" @change="reExec">手动开奖</el-radio>
              <el-radio :label="2" @change="autoExec">自动开奖</el-radio>
              <el-form-item v-show="form.resource==2" style="display: inline-block;" prop="minu">
                <el-input-number class="number_text" v-model="form.minu" controls-position="right" :min="0" :max='9' :precision="0"></el-input-number><span class="minu">分</span>
                <el-input-number class="number_text" v-model="form.secd" controls-position="right" :min="0" :max='59' :precision="0"></el-input-number><span class="minu">秒后自动开奖</span>
              </el-form-item>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="参与方式：" prop="join">
            <el-radio-group v-model="form.join">
              <el-radio label="1">直播间全体学员自动参与</el-radio>
              <el-radio label="2">学员手动参与</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动规则：" prop="rule">
            <el-input placeholder='请输入，最多20字' maxlength=20 v-model="form.rule"></el-input>
          </el-form-item>
          <el-form-item label="指定中奖人：" prop="winner" style="margin-bottom: 0;">
            <el-input placeholder='最多输入3个指定中奖人的手机号, 多个之间用&分隔开' maxlength=35 v-model="form.winner"></el-input>
            <div style="color:#999">指定中奖人需要进入直播间内参与抽奖</div>
          </el-form-item>
           <el-form-item class="create_btn">
            <el-button @click="onSubmit(0)">保存</el-button>
            <el-button @click="onCancel">取消</el-button>
            <!-- <el-button @click="onSubmit(1)">立即发起抽奖</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import assembly from 'components/offcn-teacher-lottery/content'
import { Toast } from 'mint-ui'

export default {
  data () {
    var checktime = (rule, val, callback) => {
      this.check_num(callback)
    }
    // 指定中奖人输入框失去焦点校验
    var checkWinnerRule = (rule, val, callback) => {
      let regPhone = /^1[3456789]\d{9}$/
      let winnerPhoneArr = val.split('&')
      if (val === '') {
        callback()
        this.allValid = true
      } else if (winnerPhoneArr.length > 3) {
        callback(new Error('指定中奖人不得超过3个'))
      } else if (winnerPhoneArr.every(e => regPhone.test(e))) {
        // 判断手机号是否已经在中公教育App注册过
        this.$api.GETSSOINFO(JSON.stringify({
          phoneList: winnerPhoneArr
        })).then(res => {
          if (res.code === 0) {
            let noRegisterList = winnerPhoneArr.filter(e => !res.data[e])
            if (noRegisterList.length > 0) {
              // 未注册过
              callback(new Error(` [${noRegisterList}] 指定中奖人未在中公教育App注册`))
              this.allValid = false
            } else {
              // 通过
              callback()
              this.allValid = true
            }
          }
        })
      } else {
        callback(new Error('输入手机号格式有误'))
        this.allValid = false
      }
    }
    return {
      isshow: true,
      ssoid: '',
      id: 0,
      isdel: 0,
      roomId: this.$route.query.roomid,
      arr: [],
      isdefault: 1,
      level: ['一', '二', '三', '四', '五'],
      isadd: true,
      form: {
        resource: 1,
        join: '',
        rule: '',
        winner: '',
        minu: 0,
        secd: 0
      },
      rules: {
        resource: [
          {required: true, message: '请选择开奖方式'}
        ],
        join: [
          {required: true, message: '请选择参与方式'}
        ],
        minu: [
          {required: true, validator: checktime}
        ],
        winner: [
          {validator: checkWinnerRule}
        ]
      },
      assemblyArr: [],
      saveData: '',
      params: this.$route.params.id,
      winData: [{
        name: '',
        num: 0,
        type: [],
        desc: '',
        goods: '',
        cargo: '',
        coupon: '',
        cargoname: [],
        isCommodity: false,
        isGoods: false,
        isCoupon: false,
        isShowCouponError: false,
        couponText: '',
        tableData: [{
          cargo: '',
          expiryDateType: '',
          periodDays: '',
          periodDate: '',
          studyPlatform: [],
          showCidError: false
        }],
        isSkus: false,
        skuList: [],
        callback: true
      }], // 一等奖中奖数据
      allValid: true,
      winMoreData: [], // 其他中奖信息
      skuList: [] // 商品对应的sku数据
    }
  },
  mounted () {
    if (Number(this.$route.query.id)) {
      this.getliveDrawEdit()
    }
    this.ssoId = window.sessionStorage.getItem('s')
    sessionStorage.setItem('callback', true)
  },
  components: {
    assembly
  },
  methods: {
    check_num (callback) {
      if (this.form.resource === 2 && this.form.minu === 0 && this.form.secd === 0) {
        callback('时间必须大于0秒') // eslint-disable-line
      } else {
        callback() // 必须写
      }
    },
    // 时间戳处理，不足10补0
    addZero (m) {
      return m < 10 ? '0' + m : m
    },
    timeFormat (timestamp) {
      var time = ''
      time = new Date(timestamp)
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var date = time.getDate()
      return (
        year + '-' + this.addZero(month) + '-' + this.addZero(date)
      )
    },
    // 保存和发起抽奖
    onSubmit (start) {
      let arr = []
      let skuObj = {}
      this.$children.map((item) => {
        if (item.$refs && item.$refs.form && item.$refs.form && item.$refs.form.length > 0) {
          item.$refs.form.forEach((key) => {
            arr.push(key.model)
          })
        }
        if (item.$refs && item.$refs.cargotable && item.$refs.cargotable.length > 0) {
          item.$refs.cargotable.forEach((val) => {
            // 格式化自定义日期和天数数据
            val && val.data.length > 0 && val.data.forEach((item) => {
              if (item.expiryDateType === 6) {
                item.periodDate = ''
              } else if (item.expiryDateType === 7) {
                item.periodDays = 0
                item.periodDate = this.timeFormat(new Date(item.periodDate).getTime())
              } else {
                item.periodDays = item.expiryDateType
                item.periodDate = ''
              }
            })
          })
          arr.forEach((i, index) => {
            skuObj = {} // 处理goodsIdSkuList数据
            i.skuList && i.skuList.length > 0 && i.skuList.forEach((key) => {
              skuObj[key.id] = key.newCarName
            })
            i.skuObj = skuObj
            i.cargoCodeList = item.$refs.cargotable[index] && item.$refs.cargotable[index].data
          })
        }
      })
      arr = arr.map((item, i) => {
        // 如果奖品类型没选中 对应的数据数组 设为空
        let prizeType = []
        let goodsIdList = []
        let couponIDList = []

        for (let i in item.type) {
          prizeType.push(Number(item.type[i]))
        }
        for (let i in item.goods.split('&')) {
          if (prizeType.includes(1)) {
            if (item.goods) {
              goodsIdList.push(Number(item.goods.split('&')[i]))
            } else {
              this.allValid = false
            }
          } else {
            goodsIdList = []
            item.callback = true
          }
        }
        for (let i in item.coupon.split('&')) {
          if (prizeType.includes(3)) {
            if (item.coupon) {
              couponIDList.push(Number(item.coupon.split('&')[i]))
            } else {
              this.allValid = false
            }
          } else {
            couponIDList = []
            item.callback = true
          }
        }
        return item = {// eslint-disable-line
          id: item.id,
          isDel: item.isdel,
          name: item.name,
          newName: item.newName,
          level: i + 1,
          num: item.num,
          desc: item.desc,
          prizeType: prizeType,
          goodsIdList: goodsIdList || [],
          goodsIdSkuList: [],
          cargoCodeList: prizeType.includes(2) ? item.cargoCodeList : [],
          couponIDList: couponIDList || [],
          skuList: item.skuList,
          callback: item.callback
        }
      })

      this.$children.forEach((i) => {
        console.log(i)
        if (i.$refs || !i.$refs.form) {
          if (i.$refs.form && i.$refs.form.length > 0) {
            i.$refs.form.forEach(v => {
              v.validate((valid) => {
                if (!valid) {
                  this.allValid = false
                }
              })
            })
          } else {
            i.validate((valid) => {
              if (!valid) {
                this.allValid = false
              }
            })
          }
        }
      })
      console.log(arr)
      if (arr[0].name === '' || arr[0].newName === '' || arr[0].prizeType.length === 0 || !arr[0].num || !arr[0].callback) {
        this.allValid = false
      }
      if (this.allValid && sessionStorage.getItem('callback') === 'true' && sessionStorage.getItem('formError') !== 'true') {
        this.$api.LIVEDRAWEDIT({
          id: Number(this.$route.query.id),
          roomId: this.roomId,
          RunMethod: Number(this.form.resource),
          joinMethod: Number(this.form.join),
          adminSsoId: this.ssoid,
          rule: this.form.rule,
          drawCountdownSecond: this.form.minu * 60 + this.form.secd,
          drawPrizes: arr,
          start: start,
          backdoorPhoneList: this.form.winner.split('&')
        }).then(res => {
          // 和客户端交互
          if (res.code === 0) {
            if (start === 1) {
              Toast({
                message: '发起成功',
                className: 'offcn-toast'
              })
              setTimeout(function () {
                window.history.go(-1)
              }, 100)
              if (!webAccessor) return // eslint-disable-line
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                path: 'start_lottery',
                data: {
                  dataInfo: res.data,
                  roomId: this.$route.query.roomId
                }
              }))
            } else {
              Toast({
                message: '保存成功',
                className: 'offcn-toast'
              })
              setTimeout(function () {
                window.history.go(-1)
              }, 100)
            }
          } else {

          }
        }, err => {
          console.log(err)
        })
      } else {
        console.log('error submit!!')
        return false
      }
    },
    // 取消创建
    onCancel: function () {
      window.history.go(-1)
    },
    add_prize () {
      if (this.arr.length < 5) {
        this.winData.push({
          name: '',
          num: 0,
          type: [],
          desc: '',
          goods: '',
          cargo: '',
          coupon: '',
          cargoname: [],
          isCommodity: false,
          isGoods: false,
          isCoupon: false,
          tableData: [{
            cargo: '',
            expiryDateType: '',
            periodDays: '',
            periodDate: '',
            studyPlatform: [],
            showCidError: false
          }],
          isSkus: false,
          skuList: []
        })
        this.isdefault++
        console.log(this.isdefault, this.arr)
      }
      if (this.winData.length === 5) {
        this.isadd = false
      }
    },
    getliveDrawEdit (data) {
      this.$api.DRAWDETAIL({
        id: Number(this.$route.query.id)
      }).then(res => {
        if (res.code === 0 && res.data && res.data.draw) {
          this.form.resource = res.data.draw.runMethod
          this.form.join = String(res.data.draw.joinMethod)
          this.form.rule = res.data.draw.rule
          this.form.winner = res.data.backdoorPhoneList.join('&')
          this.form.minu = parseInt((res.data.draw.drawCountdownSecond) / 60) // 取整
          this.form.secd = res.data.draw.drawCountdownSecond % 60 // 取余
          if (res.data.draw && res.data.draw.drawPrizes) {
            res.data.draw.drawPrizes.forEach(i => {
              // 变量先赋值 最后给windata数据赋值 防止数据深拷贝之后修改不生效
              i.type = i.prizeType
              i.coupon = i.couponIdList && i.couponIdList.join('')
              i.goods = i.goodsIdList && i.goodsIdList.join('&')
            })
            this.winData = res.data.draw.drawPrizes
          }
        } else {
          Toast({
            message: res.msg,
            className: 'offcn-toast'
          })
        }
      }, err => {
        Toast({
          message: err,
          className: 'offcn-toast'
        })
        console.log(err)
      })
    },
    // 后退
    back_list () {
      history.go(-1)
    },
    reExec () {
      this.form.minu = 0
      this.form.secd = 0
    },
    autoExec () {
      this.form.minu = 0
      this.form.secd = 30
    },
    delAwards (val) {
      if (this.winData.length === 1) return
      this.winData.splice(val, 1)
      // 删除奖项后  需要展示添加奖项按钮
      if (this.arr.length < 4) {
        this.isadd = true
      }
      this.isdefault = Number(this.arr.length) + 1
    },
    getSkuList (val) {
      this.skuList = val
      console.log(val)
    }
  }
}
</script>

<style scoped lang="scss">
.top_form {
  max-height: 500px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
}
/deep/.number_text {
  width: 70px;
  .el-input input {
    width: 100%;
  }
}
/deep/.el-input-number.is-controls-right .el-input__inner {
  padding-right: 38px;
}
/deep/.el-form-item__label {
  padding: 0;
}
/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #0d152d;
}
/deep/.el-input input {
  width: 440px;
  height: 30px;
  font-size: 12px;
}
/deep/.el-input-number .el-input .el-input__inner {
  height: 30px;
}
/deep/.el-input-number.is-controls-right .el-input-number__increase {
  top: 5px;
  width: 20px;
  height: 14px;
  line-height: 15px;
}
/deep/.el-input-number.is-controls-right .el-input-number__decrease {
  top: 18px;
  width: 20px;
  height: 15px;
  line-height: 15px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #fe895f;
  background: #ffffff;
}
/deep/.el-radio__inner::after {
  width: 6px;
  height: 6px;
  background: #fe895f;
}
/deep/.el-form-item .el-form-item__label {
  padding: 0;
}
.el-button:hover {
  color: #ffffff;
  border: 1px solid #fe895f;
  background: #fe895f;
}
.lottery-wrapper {
  p {
    margin: 0;
  }
  .join_lottery {
    background: #ffffff;
    .lottery_box {
      padding: 16px 24px;
    }
    .lottery_btn {
      text-align: center;
      .back_list {
        float: left;
        cursor: pointer;
      }
    }
    .introduce {
      font-size: 12px;
      color: #949bab;
      margin-left: 10px;
    }
    .add_prize {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #fe895f;
      // border-top: 1px solid #e5e5e5;
      cursor: pointer;
    }
    .information {
      font-size: 14px;
      margin-top: 20px;
      margin-bottom: 14px;
    }
    .create_btn {
      text-align: right;
    }
    .minu {
      font-size: 14px;
      margin: 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-lottery/create.vue